var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c("h4", { staticClass: "mt-2 mb-2" }, [
                _vm._v(
                  _vm._s(_vm._.get(_vm.requestForm, "form.type_form_str", ""))
                )
              ]),
              _c("vs-divider")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "9" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("incident_form_protocol"),
                    "label-for": "protocol"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "protocol",
                      value: _vm._.get(_vm.requestForm, "form.protocol_number"),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "print:hidden content-center", attrs: { md: "3" } },
            [
              _c("ProtocolQueryHistoryPopup", {
                attrs: {
                  protocol_number: _vm._.get(
                    _vm.requestForm,
                    "form.protocol_number"
                  ),
                  type: "incident"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("incident_form_date"),
                    "label-for": "incident_form_date"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "incident_form_date",
                      value: _vm._.get(
                        _vm.requestForm,
                        "form.incident_date_fmt"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("incident_form_responsible_email"),
                    "label-for": "incident_form_responsible_email"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "incident_form_responsible_email",
                      value: _vm._.get(
                        _vm.requestForm,
                        "form.responsible_email"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._.get(_vm.requestForm, "form.type_form") === "GE"
        ? _c("FormIncidentGeneralDetail", {
            attrs: { entity: _vm._.get(_vm.requestForm, "form") }
          })
        : _vm._e(),
      _vm._.get(_vm.requestForm, "form.type_form") === "CA"
        ? _c("FormIncidentCoupAttemptDetail", {
            attrs: { entity: _vm._.get(_vm.requestForm, "form") }
          })
        : _vm._e(),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c("h5", { staticClass: "mt-2 mb-0" }, [
                _vm._v(_vm._s(_vm.$t("incident_form_handling")))
              ]),
              _c("vs-divider")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("incident_form_status"),
                    "label-for": "status"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "status",
                      value: _vm._.get(_vm.requestForm, "status_str"),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "print:hidden content-center", attrs: { lg: "8" } },
            [
              _c("HandlingHistoryPopup", {
                attrs: {
                  id: _vm.id,
                  serviceDelegate: _vm.services.incidentFormHandlingService
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }